import React, {useState} from "react";
import {Button, Input, message} from 'antd';
import { useNavigate } from "react-router-dom";
import { CreditCardOutlined, BankOutlined } from '@ant-design/icons';
import CartItem from "../components/cart/CartItem";
import RequestApi from "../api/RequestApi";
import { updateDataThunk } from "../redux/slices/cartSlice";
import { useDispatch } from "react-redux";

const CartPage = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isMultiple, setMultiple] = useState(false);
    const [total, setTotal] = useState(0);
    const [items, setItems] = React.useState([]);
    const [isUpdate, setIsUpdate] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isValidate, setIsValidate] = React.useState(false);

    const [companyName, setCompanyName] = React.useState("");
    const [companyInn, setCompanyInn] = React.useState("");
    const [showFormCompany, setShowFormCompany] = React.useState(false);
    const [isErrorCompany, setErrorCompany] = React.useState(false);
    const [isErrorCompanyInn, setErrorCompanyInn] = React.useState(false);
    const [notifyEmails, setNotifyEmails] = React.useState("");

    const onReload = () => {
        RequestApi.get('private/cart').then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS && data.content.items !== undefined) {
                setItems(data.content.items);
                let cartTotal = 0;
                data.content.items.forEach((item) => {
                    cartTotal += item.price * item.quantity;
                })
                setTotal(cartTotal);
            } else {
                navigate('/cabinet/catalog');
            }
        })
    }

    const onUpdate = (isShowLoader = true) => {
        setIsUpdate(isShowLoader);
        RequestApi.post('private/cart', {
            items: items,
        }).then((data) => {
            setIsUpdate(false);
            dispatch(updateDataThunk());
            if (data.status === RequestApi.STATUS_SUCCESS) {

            } else {
                onReload();
            }
        }).catch((err) => {
            setIsUpdate(false);
        });
    }

    const onChangeItem  = (id, qty, fromDt = null, toDt = null) => {
        let cartTotal = 0;
        let tItems = items;
        let removes = [];
        tItems.forEach((item, index) => {
            if (item.id === id) {
                if (qty > 0) {
                    tItems[index].quantity = qty;
                    tItems[index].fromDt = fromDt;
                    tItems[index].toDt = toDt;
                } else {
                    removes.push(index)
                    return;
                }
            }
            cartTotal += item.price * item.quantity;
        })
        removes.forEach((index) => {
            tItems.splice(index, 1);
        })
        setItems(tItems);
        setTotal(cartTotal);
        onUpdate();
    }

    const onChangeItemConsumers = (id, consumers) => {
        let tItems = items;
        tItems.forEach((item, index) => {
            if (item.id === id) {
                tItems[index].consumers = consumers;
            }
        })
        setItems(tItems);
        onUpdate(false);
    }

    const onConfirmPay = (payment) => {
        console.log('onConfirmPay');

        if (payment === 'invoice') {
            setErrorCompany(false);
            setErrorCompanyInn(false);
            if (companyName === '') {
                setErrorCompany(true);
                setShowFormCompany(true);
            }
            if (companyInn === '') {
                setErrorCompanyInn(true);
                setShowFormCompany(true);
            }
            if (companyName === '' || companyInn === '') {
                return;
            }
        }

        if (isMultiple) {
            let isError = false;
            let isErrorDates = false;
            items.forEach((item) => {
                if (item.quantity > item.consumers.length) {
                    isError = true;
                    console.log('no qty');
                }
                item.consumers.forEach((consumer, ind) => {
                    if (ind + 1 > item.quantity) return;
                    if (consumer.surname.length < 2 || consumer.name.length < 2 || consumer.phone.length < 18) {
                        isError = true;
                        console.log('no field');
                    }
                })
                if ((item.fromDt && !item.toDt) || (!item.fromDt && item.toDt)) {
                    isErrorDates = true;
                }
            })
            if (isError || isErrorDates) {
                setIsValidate(true);
                console.log('event error');
                if (isError) {
                    message.error('Заполните все обязательные поля: Имя, Фамилия, номер телефона');
                }
                if (isErrorDates) {
                    message.error('Укажите оба поля "Даты доступа"');
                }
                return null;
            }
        }

        console.log('order confirm');

        setIsUpdate(true);
        RequestApi.post('private/cart/order', {
            ism: isMultiple ? 1 : 0,
            payment: payment,
            company_name: companyName,
            company_inn: companyInn,
            notify_emails: notifyEmails
        }).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                if (payment === 'card' && data.content.item.payment.card !== undefined) {
                    window.location.href = data.content.item.payment.card;
                }
                if (payment === 'invoice' && data.content.item.payment.invoice !== undefined) {
                    window.open(data.content.item.payment.invoice, "_blank");
                }
                navigate('/cabinet/orders');
                dispatch(updateDataThunk());
            } else {
                if (data.error.messages !== undefined) {
                    message.error(data.error.messages.join(' '));
                }

            }
            setIsUpdate(false);
        }).catch((err) => {
            console.log(err);
            setIsUpdate(false);
        })

    }

    React.useEffect(() => {
        let cartTotal = 0;
        items.forEach((item, index) => {
            if (isMultiple) {
                cartTotal += item.price * item.quantity;
            } else {
                cartTotal += item.price;
            }
        })
        setTotal(cartTotal);
    }, [isMultiple])

    React.useEffect(() => {
        onReload();

        // подгрузим данные юзера
        RequestApi.get('private/user/current').then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                setCompanyName(data.content.item.company);
                setCompanyInn(data.content.item.company_inn);
            }
        })

    }, [])

    return <>
        <div className="flex w-9/12 mob-w-full m-auto items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    Оформление заказа
                </h2>
            </div>
        </div>

        {
            items.length > 0 &&
            <div className={'flex w-9/12 mob-w-full mob-block m-auto gap-2'}>
                <div className={'w-8/12  mob-w-full m-auto'}>
                    <div className={'card px-4 py-4 flex-row justify-between gap-2 mob-block'}>
                        <div className={'w-6/12 mob-w-full'}>
                            <Button className={'w-full ' + (!isMultiple && 'bg-slate-150')}
                                    onClick={() => setMultiple(false)}
                                    type={'default'}>Покупка для себя</Button>
                        </div>
                        <div className={'w-6/12 mob-w-full mob-mt-2'}>
                            <Button className={'w-full ' + (isMultiple && 'bg-slate-150')}
                                    onClick={() => setMultiple(true)}
                                    type={'default'}>Покупка нескольких копий</Button>
                        </div>
                    </div>
                    {
                        isMultiple && <div className={'card px-4 py-4 mt-3'}>
                            <Input placeholder={'Дополнительные E-mail адреса для получения информации по заказу (через запятую)'} value={notifyEmails}  onChange={(e) => setNotifyEmails(e.target.value)}/>
                        </div>
                    }
                    <div className="card px-4 py-4 mt-3">
                        {
                            items.map((item, index) => (
                                <CartItem item={item} isMultiple={isMultiple} isValidate={isValidate} onChangeItemConsumers={onChangeItemConsumers} onChangeItem={onChangeItem}
                                          key={item.id}/>
                            ))
                        }
                    </div>
                </div>
                <div className={'w-4/12 mob-w-full mob-mt-4 m-auto mt-0'}>
                    <div className={'card mob-w-full px-4 py-4 fixed mob-no-fixed'}
                         style={{opacity: isUpdate ? 0.5 : 1, pointerEvents: isUpdate ? 'none' : 'auto'}}>
                        <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                            Сумма заказа:
                        </h2>
                        <div className={'py-6 text-3xl text-center font-bold'}>{total} руб.</div>
                        <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                            Выберите способ оплаты
                        </h2>
                        <div className="items-center flex-row justify-between gap-2 mt-3">
                            <div className={'w-full'}>
                                <Button className={'w-full h-12'}
                                        type={'primary'} onClick={() => onConfirmPay('card')}>
                                    <CreditCardOutlined/> Оплатить картой</Button>
                            </div>
                            {
                                showFormCompany && <div className={'py-3'}>
                                    <div className={'pb-2'}>Введите данные:</div>
                                    <div className={'pb-2'}>
                                        <Input status={isErrorCompany && 'error'} value={companyName} onChange={(e) => setCompanyName(e.target.value)}
                                               placeholder={'Название компании'}/>
                                    </div>
                                    <div>
                                        <Input status={isErrorCompanyInn && 'error'} value={companyInn} onChange={(e) => setCompanyInn(e.target.value)}
                                               placeholder={'ИНН компании'}/>
                                    </div>
                                </div>
                            }
                            <div className={'w-full mt-3'}>
                                <Button className={'w-full h-12'}
                                        type={'primary'} onClick={() => onConfirmPay('invoice')}>
                                    <BankOutlined/> Оплатить по счету</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }


    </>
}

export default CartPage;
